var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "product"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24094 7.287L11.7619 11.923C11.9089 12.003 12.0909 12.003 12.2389 11.923L20.7599 7.287C21.1029 7.1 21.0729 6.622 20.7079 6.475L12.1879 3.036C12.0679 2.988 11.9319 2.988 11.8119 3.036L3.29194 6.475C2.92794 6.622 2.89794 7.1 3.24094 7.287ZM20.7082 10.6562L18.8782 9.8762L12.2392 13.4882C12.0912 13.5682 11.9092 13.5682 11.7612 13.4882L5.12224 9.8762L3.29224 10.6562C2.92724 10.8112 2.89724 11.3172 3.24124 11.5142L11.7612 16.4112C11.9092 16.4962 12.0912 16.4962 12.2392 16.4112L20.7592 11.5142C21.1032 11.3172 21.0732 10.8112 20.7082 10.6562ZM19.1512 14.4226L20.7082 15.0966C21.0732 15.2546 21.1032 15.7676 20.7592 15.9676L12.2392 20.9356C12.0912 21.0216 11.9092 21.0216 11.7612 20.9356L3.24124 15.9676C2.89724 15.7676 2.92724 15.2546 3.29224 15.0966L4.84924 14.4226L11.7612 18.1836C11.9092 18.2636 12.0912 18.2636 12.2392 18.1836L19.1512 14.4226Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.b959d151a532c175fc7a03a06ddf5afd.svg";
export { ForwardRef as ReactComponent };